export const ADMIN_ACCESS = Object.freeze({
  DASHBOARD: "dashboard",
  INVOICES: "invoices",
  BOOKINGS: "bookings",
  BOOK_TRAINING: "bookTraining",
  SERVICE_REQUESTS: "serviceRequests",
  PAYOUTS: "payouts",
  REVIEWS: "reviews",
  PARENT_HUB: "parentHub",
  ENGAGEMENT: "engagement",
  CLIENTS: "clients",
  CAREGIVERS: "caregivers",
  CONTRACTS: "contracts",
  VETTING: "vetting",
  SERVICE_CATEGORIES: "serviceCategories",
});

export const ADMIN_MODULE_LABELS = Object.freeze({
  [ADMIN_ACCESS.DASHBOARD]: "Dashboard",
  [ADMIN_ACCESS.INVOICES]: "Invoices",
  [ADMIN_ACCESS.BOOKINGS]: "Bookings",
  [ADMIN_ACCESS.BOOK_TRAINING]: "Book & Training",
  [ADMIN_ACCESS.SERVICE_REQUESTS]: "Service Requests",
  [ADMIN_ACCESS.PAYOUTS]: "Payouts",
  [ADMIN_ACCESS.REVIEWS]: "Reviews",
  [ADMIN_ACCESS.PARENT_HUB]: "Parent Hub",
  [ADMIN_ACCESS.ENGAGEMENT]: "Engagement",
  [ADMIN_ACCESS.CLIENTS]: "Clients",
  [ADMIN_ACCESS.CAREGIVERS]: "Caregivers",
  [ADMIN_ACCESS.CONTRACTS]: "Contracts",
  [ADMIN_ACCESS.VETTING]: "Vetting",
  [ADMIN_ACCESS.SERVICE_CATEGORIES]: "Service Categories",
});

export const ADMIN_DEPARTMENTS = Object.freeze({
  finance: {
    label: "Finance",
    access: [
      ADMIN_ACCESS.DASHBOARD,
      ADMIN_ACCESS.INVOICES,
      ADMIN_ACCESS.BOOKINGS,
      ADMIN_ACCESS.BOOK_TRAINING,
      ADMIN_ACCESS.SERVICE_REQUESTS,
      ADMIN_ACCESS.PAYOUTS,
    ],
  },
  marketing: {
    label: "Marketing",
    access: [
      ADMIN_ACCESS.DASHBOARD,
      ADMIN_ACCESS.REVIEWS,
      ADMIN_ACCESS.PARENT_HUB,
      ADMIN_ACCESS.ENGAGEMENT,
      ADMIN_ACCESS.CLIENTS,
    ],
  },
  operations: {
    label: "Operations",
    access: [
      ADMIN_ACCESS.DASHBOARD,
      ADMIN_ACCESS.CAREGIVERS,
      ADMIN_ACCESS.BOOKINGS,
      ADMIN_ACCESS.SERVICE_REQUESTS,
      ADMIN_ACCESS.BOOK_TRAINING,
      ADMIN_ACCESS.CONTRACTS,
      ADMIN_ACCESS.REVIEWS,
      ADMIN_ACCESS.VETTING,
      ADMIN_ACCESS.CLIENTS,
    ],
  },
  talent_acquisition: {
    label: "Talent Acquisition & Placement",
    access: [
      ADMIN_ACCESS.DASHBOARD,
      ADMIN_ACCESS.CAREGIVERS,
      ADMIN_ACCESS.BOOKINGS,
      ADMIN_ACCESS.SERVICE_REQUESTS,
      ADMIN_ACCESS.CONTRACTS,
      ADMIN_ACCESS.VETTING,
      ADMIN_ACCESS.CLIENTS,
    ],
  },
  customer_service_qa: {
    label: "Customer Service & QA",
    access: [
      ADMIN_ACCESS.DASHBOARD,
      ADMIN_ACCESS.SERVICE_REQUESTS,
      ADMIN_ACCESS.BOOK_TRAINING,
      ADMIN_ACCESS.CONTRACTS,
      ADMIN_ACCESS.REVIEWS,
      ADMIN_ACCESS.VETTING,
      ADMIN_ACCESS.ENGAGEMENT,
      ADMIN_ACCESS.CLIENTS,
    ],
  },
});

export const ALL_ADMIN_ACCESS = Object.freeze(Object.values(ADMIN_ACCESS));

export const normalizeAdminAccess = (access = []) => {
  if (!Array.isArray(access)) return [];
  return [...new Set(access)].filter((item) => ALL_ADMIN_ACCESS.includes(item));
};

export const getDepartmentAccess = (department) =>
  normalizeAdminAccess(ADMIN_DEPARTMENTS[department]?.access || []);

export const canAccessModule = (adminProfile, requiredAccess) => {
  if (adminProfile?.isSuperAdmin) return true;
  const required = Array.isArray(requiredAccess)
    ? requiredAccess
    : [requiredAccess];
  const adminAccess = normalizeAdminAccess(adminProfile?.adminAccess || []);
  return required.some((access) => adminAccess.includes(access));
};
